export class BackupJobResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupJobResponse.attributeTypeMap;
    }
    constructor() {
    }
}
